import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';

const converterArquivoParaBufferArray = (arquivo) => {
  const buf = new ArrayBuffer(arquivo.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < arquivo.length; i += 1)
    // eslint-disable-next-line no-bitwise
    view[i] = arquivo.charCodeAt(i) & 0xff;
  return buf;
};

export const downloadXlsx = (sheetName, arrayLinhas, nomeArquivo) => {
  const workbook = utils.book_new();
  workbook.SheetNames.push(sheetName);
  const worksheet = utils.aoa_to_sheet(arrayLinhas);
  workbook.Sheets[sheetName] = worksheet;
  const arquivo = write(workbook, { bookType: 'xlsx', type: 'binary' });
  saveAs(
    new Blob([converterArquivoParaBufferArray(arquivo)], {
      type: 'application/octet-stream',
    }),
    `${nomeArquivo}.xlsx`
  );
};

export default downloadXlsx;
